/**
 * Maps procedure-assignment API rows to GenericFormsPage entities.
 */
export function mapProcedureAssignmentToEntity(item) {
  const doc = item.document || {};
  const rev =
    doc.currentRevision && typeof doc.currentRevision === 'object'
      ? doc.currentRevision
      : null;
  const assignmentId = item.assignmentId ?? item.id;
  const status = item.status;

  return {
    id: assignmentId,
    assignmentId,
    viewStatus: status,
    viewStatusLabel: status === 'VIEWED' ? 'Viewed' : 'Pending',
    canView: item.canView !== false,
    unavailableReason: item.unavailableReason,
    assignedAt: item.assignedAt,
    viewedAt: item.viewedAt,
    dueDate: item.dueDate,
    documentId: doc.id,
    code: doc.code,
    title: doc.title,
    notes: doc.notes,
    publishedAt: doc.publishedAt,
    publishedReason: doc.publishedReason,
    documentTypeId: doc.documentType?.id,
    documentType: doc.documentType?.name,
    departmentId: doc.department?.id,
    department: Array.isArray(doc.departments) && doc.departments.length
      ? doc.departments.map((d) => d.name).join(', ')
      : doc.department?.name,
    statusId: doc.status?.id,
    status: doc.status?.name,
    currentRevisionId: rev?.id ?? doc.currentRevisionId ?? null,
    currentRevision: rev?.version ?? '—',
    currentRevisionDetail: rev,
    fileAttachments: [],
    fileAttachmentCount: 0,
  };
}

/** Map single assignment from POST /me/:id/view or GET /me/:id */
export function mapProcedureAssignmentFromApi(dto) {
  return mapProcedureAssignmentToEntity(dto);
}
